module.exports = __webpack_public_path__ + "img/glm_gbt6181_1986.prt.7e727c70.jpg";